<template>
  <div class="container">
    <h1>{{ this.contents.find(content => content.id_content === 175)?.title  }}</h1>

    <div v-html="this.contents.find(content => content.id_content === 175)?.description"></div>

<!--    <h4>1. QUEM SOMOS</h4>-->
<!--    <p>-->
<!--      A NEARCODE é uma empresa especializada em consultoria de sistemas de-->
<!--      informação, com projetos em nearshore e em onshore. Com sede na Rua da-->
<!--      Alegria, 1988, 1º, Sala 3. 4200-024 Porto, matriculada na Conservatória do-->
<!--      Registo Comercial do Porto, sob o número de matrícula e de pessoa coletiva-->
<!--      514044624, a NEARCODE no âmbito dos seus serviços de consultoria,-->
<!--      necessita de recolher e tratar dados pessoais de candidatos,-->
<!--      colaboradores, clientes, fornecedores e terceiros. Sendo a proteção da-->
<!--      privacidade e dos dados pessoais de todos aqueles que interagem com a-->
<!--      NEARCODE uma preocupação e prioridade para nós, foi em conformidade-->
<!--      elaborada a presente política de privacidade e proteção de dados. Desta-->
<!--      forma é possível transmitir de uma forma clara e transparente as boas-->
<!--      práticas respeitantes a este processo. Todo e qualquer dado pessoal-->
<!--      fornecido será tratado com a garantia de segurança e confidencialidade-->
<!--      exigidas pelo enquadramento legal no que diz respeito à proteção de dados-->
<!--      pessoais.-->
<!--    </p>-->

<!--    <h4>2. ENQUADRAMENTO</h4>-->
<!--    <p>-->
<!--      A presente política descreve um conjunto de orientações, regras e-->
<!--      princípios que deverão ser observados pela NEARCODE para assegurar a-->
<!--      proteção dos direitos dos titulares dos dados. A NEARCODE obriga-se ao-->
<!--      cumprimento da presente política em conformidade com as obrigações do-->
<!--      Regulamento 2016/679/UE, do Parlamento Europeu e do Conselho, de 27 de-->
<!--      abril de 2016, relativo à proteção das pessoas singulares no que diz-->
<!--      respeito ao tratamento de dados pessoais e à livre circulação desses dados-->
<!--      (adiante abreviadamente designado por “RGPD”). Neste sentido, a NEARCODE-->
<!--      procura garantir que os seus procedimentos internos estão em conformidade-->
<!--      com as obrigações legais do RGPD e que os dados pessoais dos seus-->
<!--      colaboradores, clientes, fornecedores ou prestadores de serviços e de-->
<!--      quaisquer outros titulares de dados cujos dados pessoais a NEARCODE trate-->
<!--      no exercício da sua atividade, sejam tratados de acordo com as normas-->
<!--      regulamentares e legais em vigor e conservados em segurança. A NEARCODE,-->
<!--      compromete-se, com base nos artigos 5º e 24.º do Regulamento Geral de-->
<!--      Proteção de Dados, a aplicar as medidas técnicas e organizativas-->
<!--      necessárias, tendo em linha de conta a natureza, o âmbito, o contexto e a-->
<!--      finalidade dos dados recolhidos, bem como assegurar e comprovar que o-->
<!--      tratamento é realizado em conformidade com o RGPD.-->
<!--    </p>-->

<!--    <h4>3. OS SEUS DADOS PESSOAIS</h4>-->

<!--    <h5>3.1 – Como é dado o consentimento</h5>-->
<!--    <p>-->
<!--      O consentimento do titular é manifestado de forma livre, voluntária e-->
<!--      explícita, sendo obtido através de um registo da aceitação. A remoção/-->
<!--      retirada do consentimento pode ser solicitada em qualquer altura, através-->
<!--      do envio de um simples pedido para o endereço de email-->
<!--      info@nearcodeconsulting.com A NEARCODE conservará os dados pessoais que-->
<!--      tenha recebido, e adotará as medidas necessárias para evitar a sua-->
<!--      alteração, perda, tratamento ou acesso não autorizados, tendo em conta o-->
<!--      estado da tecnologia, a natureza dos dados armazenados e os riscos a que-->
<!--      estão expostos, em conformidade com o previsto na lei.-->
<!--    </p>-->
<!--    <h5>3.2 - Como recolhemos e gerimos os seus dados</h5>-->
<!--    <h6><b> A.</b> Recrutamento e Seleção</h6>-->
<!--    <p>-->
<!--      Os dados são voluntariamente fornecidos pelo candidato nos nossos canais-->
<!--      de comunicação disponíveis. Por norma, todos os dados são os que constam-->
<!--      no CV, nomeadamente, nomes, e-mail, telefone, data de nascimento,-->
<!--      experiência profissional, informações educacionais e outros dados-->
<!--      inseridos pelo próprio, com ou sem fotografia. Podemos, ainda, obter os-->
<!--      seus dados pessoais através de outros meios e fontes, como, por exemplo,-->
<!--      redes sociais profissionais, tais como o LinkedIn. Os dados em causa são-->
<!--      apenas os necessários e não excedem a finalidade original para a qual-->
<!--      foram recolhidos. Sem prejuízo do cumprimento das normas legais relativas-->
<!--      à conservação e transmissão de dados para fins legais ou exigíveis-->
<!--      judicialmente, os dados fornecidos serão tratados automaticamente, sendo-->
<!--      apenas necessários para efeitos de recrutamento (para oportunidades de-->
<!--      emprego atuais, futuras ou para uma candidatura espontânea). Os dados-->
<!--      serão mantidos em base de dados interna para que, em qualquer momento,-->
<!--      possam ser acedidos pelo departamento de Recursos Humanos da NEARCODE e-->
<!--      utilizados para efeitos de recrutamento no contexto de oportunidades-->
<!--      profissionais que possam surgir. Os dados recolhidos são ainda utilizados-->
<!--      para fins de seleção e gestão de candidaturas, divulgação de oportunidades-->
<!--      presentes e futuras e eventos de employer brand. O tratamento dos dados-->
<!--      supra referidos está legitimado pelo consentimento que é dado de forma-->
<!--      livre, espontânea e esclarecida. O consentimento pode ser retirado, a-->
<!--      qualquer altura, sem que isso afete a licitude do tratamento já efetuado,-->
<!--      bastando apenas o envio de um e-mail para info@nearcode.com Os dados-->
<!--      pessoais recolhidos para efeitos de Recrutamento e Seleção, destinam-se-->
<!--      exclusivamente a serem tratados no âmbito da colaboração com a-->
<!--      organização, permanecendo ativos até ao prazo de 24 meses.-->
<!--    </p>-->
<!--    <p>-->
<!--      <b> B.</b> Comunicação de dados a Terceiros <br />-->
<!--      No âmbito das finalidades supra referidas e apenas quando surgirem-->
<!--      oportunidades de emprego em concreto poderá a NEARCODE ceder os dados-->
<!--      recolhidos, aos seus clientes ou potenciais clientes, sediados em-->
<!--      Portugal, dentro ou fora da União Europeia. Apenas serão cedidos os dados-->
<!--      essenciais (nome e dados inseridos no curriculum vitae) para esse mesmo-->
<!--      recrutamento, sendo que serão cumpridas todas as medidas de segurança-->
<!--      necessárias a essa transmissão A NEARCODE poderá partilhar os dados-->
<!--      pessoais com outras entidades que trabalhem em seu nome para o-->
<!--      fornecimento de serviços e produtos solicitados. Contudo, a NEARCODE-->
<!--      partilhará dados pessoais para este fim apenas com terceiros cujas-->
<!--      políticas de privacidade sejam compatíveis com as suas e que aceitem-->
<!--      cumprir as políticas da NEARCODE no que diz respeito ao tratamento de-->
<!--      dados pessoais. A NEARCODE poderá também divulgar dados pessoais se: - -->
<!--      dispuser do consentimento expresso do titular dos dados para a partilha-->
<!--      dos mesmos para um fim específico; - necessitar de responder a intimações,-->
<!--      ordens do tribunal ou a processos legais similares; - necessitar de-->
<!--      proteger a segurança pessoal dos utilizadores do seu sítio ou de defender-->
<!--      os seus direitos e propriedade; - tiver conhecimento de que as ações do-->
<!--      titular dos dados no sítio da NEARCODE violam as suas diretrizes de-->
<!--      utilização relativamente a produtos ou serviços específicos.-->
<!--    </p>-->
<!--    <p>-->
<!--      <b> C. </b>Rastreio de ID de Utilizador <br />-->
<!--      A NEARCODE utiliza o Google Analytics para rastrear e analisar os acessos-->
<!--      e a utilização do seu sítio. O Google Analytics atribui um identificar-->
<!--      único de utilizador no momento em que o utilizador executa os processos de-->
<!--      autenticação e de acesso. O Google Analytics rastreia, em nome da-->
<!--      NEARCODE, o fluxo dos utilizadores, a sua localização por país, a língua,-->
<!--      o navegador e o sistema operativo, o fornecedor de acesso à Internet e os-->
<!--      dispositivos utilizados para aceder ao sítio da NEARCODE. A NEARCODE-->
<!--      regista estes dados para melhorar o serviço prestado aos seus clientes. A-->
<!--      NEARCODE não carrega quaisquer dados que permitam ao Google identificar um-->
<!--      indivíduo (como, por exemplo, nome, número de Segurança Social ou endereço-->
<!--      eletrónico) ou dados que identifiquem de forma definitiva dispositivos-->
<!--      específicos (tais como o endereço IP). Para desativar o Analytics na-->
<!--      Internet, o utilizador deverá aceder à página de exclusão do Google-->
<!--      Analytics e instalar o add-on para o seu navegador. Para mais informação-->
<!--      sobre a instalação ou a desinstalação deste add-on, consultar por favor-->
<!--      informação de ajuda relevante para o navegador em causa.-->
<!--    </p>-->
<!--    <p><b> D. </b> Cookies</p>-->
<!--    <p>-->
<!--      A NEARCODE utiliza cookies no seu site. Ao utilizar o site (o Serviço),-->
<!--      estará a autorizar a utilização de cookies. A nossa política de cookies-->
<!--      explica em que consistem os cookies, como os usamos, como terceiros que-->
<!--      possam ser nossos parceiros podem utilizar os cookies no site, as opções-->
<!--      do utilizador relativamente aos cookies e outras informações acerca dos-->
<!--      cookies.-->
<!--    </p>-->
<!--    <p>- O QUE SÃO COOKIES?</p>-->
<!--    <p>-->
<!--      Os cookies são pequenos ficheiros de texto enviados pelo browser pelos-->
<!--      sites que visita. Um ficheiro cookie é armazenado no browser e permite ao-->
<!--      Serviço ou ao terceiro reconhecer o utilizador e fazer com que a sua-->
<!--      próxima visita seja mais fácil e o serviço lhe seja mais útil. Os cookies-->
<!--      podem ser “persistentes” ou “de sessão”.-->
<!--    </p>-->
<!--    <p>- COMO É QUE A NEARCODE UTILIZA OS COOKIES?</p>-->
<!--    <p>-->
<!--      Quando utiliza e acede ao Serviço, a NEARCODE poderá colocar no seu-->
<!--      browser ficheiros de cookies. A NEARCODE utiliza cookies para os seguintes-->
<!--      fins: para permitir determinadas funções do Serviço, para fornecer-->
<!--      análises, para armazenar as suas preferências, para permitir a-->
<!--      disponibilização de anúncios publicitários, incluindo publicidade-->
<!--      comportamental. O Serviço da NEARCODE utiliza cookies de sessão e cookies-->
<!--      persistentes e diferentes tipos de cookies para executar o Serviço:-->
<!--      cookies estritamente necessários. A NEARCODE poderá recorrer a cookies-->
<!--      estritamente necessários para autenticação de utilizadores e para-->
<!--      prevenção de utilização fraudulenta de contas.-->
<!--    </p>-->
<!--    <p>- COOKIES DE TERCEIROS</p>-->
<!--    <p>-->
<!--      Para além dos cookies próprios, a NEARCODE poderá utilizar vários cookies-->
<!--      de terceiros com o objetivo de gerar relatórios estatísticos de utilização-->
<!--      do Serviço, de disponibilizar publicidade acerca de e através do Serviço,-->
<!--      entre outros. - COMO PODE O UTILIZADOR GERIR OS COOKIES? Se optar por-->
<!--      apagar os cookies ou configurar o seu browser para apagar ou recusar-->
<!--      cookies, consulte, por favor, as páginas de ajuda do seu browser. Tenha,-->
<!--      no entanto, em atenção que se apagar os cookies ou recusar aceitá-los-->
<!--      poderá não conseguir utilizar todas as funcionalidades disponibilizadas ou-->
<!--      guardar as suas preferências, e algumas das páginas do nosso site poderão-->
<!--      não funcionar corretamente.-->
<!--    </p>-->

<!--    <h5>4. EXERCÍCIO DOS DIREITOS DO TITULAR DOS DADOS</h5>-->

<!--    <p>-->
<!--      De acordo com as disposições do RGPD, o utilizador pode exercer a todo o-->
<!--      tempo os seus direitos de acesso, retificação, apagamento, limitação,-->
<!--      oposição, portabilidade e retirada do consentimento, através de-->
<!--      solicitação escrita por qualquer um dos seguintes meios, especificando o-->
<!--      direito ou direitos que deseja exercer: <br />-->
<!--      − E-mail: info@nearcodeconsulting.com <br />-->
<!--      - Via Postal: Rua da Alegria, 1988, 1º, Sala 3. 4200-024 Porto Nos termos-->
<!--      legais, o titular dos dados tem o direito de apresentar uma reclamação em-->
<!--      matéria de proteção de dados pessoais à autoridade de controlo competente,-->
<!--      a Comissão Nacional de Proteção de Dados (CNPD): www.cnpd.pt.-->
<!--    </p>-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
// import Content from "@/components/Content.vue";

export default {
  components: {
    // Content,
  },
  data: function () {
    return {
      contents: [],
    };
  },
  mounted() {
    this.getAllContent();
  },
  methods: {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page == 9) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({name: "Error"});
      }
    }
  },
  computed: {
    ...mapGetters(["getContent"]),
  },
};
</script>

<style scoped>
h1 {
  padding: 50px 0px 30px 0px;
  text-align: center;
}

@media (max-width: 1000px) {
  .container {
    text-align: center;
  }
}
</style>
